/*
 * @Author: Liux
 * @Date: 2019-09-24 06:16:39
 * @LastEditor: Liux
 * @LastEditTime: 2020-10-19 15:47:16
 */
import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdButtonModule } from './ad-button/ad-button.module';
import { AdTabMenuModule } from './ad-tab-menu/ad-tab-menu.module';
import { AdSelectModule } from './ad-select/ad-select.module';
import { AdDropdownListModule } from './ad-dropdown-list/ad-dropdown-list.module';
import { AdLinkMenuModule } from './ad-link-menu/ad-link-menu.module';
import { AdLineLoadingModule } from './ad-line-loading/ad-line-loading.module';
import { AdDividerModule } from './ad-divider/ad-divider.module';
import { AdTextModule } from './ad-text/ad-text.module';
import { AdMultipleDropdownModule } from './ad-multiple-dropdown/ad-multiple-dropdown.module';
import { AdModalModule } from './ad-modal/ad-modal.module';
import { AdCheckBoxModule } from './ad-check-box/ad-check-box.module';
import { AdAlertModule } from './ad-alert/ad-alert.module';
import { AdSkeletonModule } from './ad-skeleton/ad-skeleton.module';
import { AdDialogModule } from './ad-dialog/ad-dialog.module';
import { AdUploadModule } from './ad-upload/ad-upload.module';
import { AdExpansionModule } from './ad-expansion/ad-expansion.module';
import { AdCommonModule } from './ad-common/ad-common.module';
import { AdDatePickerModule } from './ad-date-picker/ad-date-picker.module';
import { AdDateRangeModule } from './ad-date-range/ad-date-range.module';
import {
  CalendarModule,
  DateAdapter,
  CalendarDateFormatter,
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AdCalendarDateFormatter } from './ad-calendar-date-formatter.provider';
import { AdTooltipModule } from './ad-tooltip/ad-tooltip.module';
import { AdUploadAreaModule } from './ad-upload-area/ad-upload-area.module';
import { AdProgressModule } from './ad-progress/ad-progress.module';
import { AdAutocompleteModule } from './ad-autocomplete/ad-autocomplete.module';
import { AdSelectButtonModule } from './ad-select-button/ad-select-button.module';
import { AdToggleButtonModule } from './ad-toggle-button/ad-toggle-button.module';
import { ADateRangeSliderModule } from './a-date-range-slider';
import { EllipsisModule } from './ellipsis/ellipsis.module';
import { UICarouselModule } from './ui-carousel/ui-carousel.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    AdTextModule,
    AdTabMenuModule,
    AdSelectModule,
    AdDropdownListModule,
    AdLinkMenuModule,
    AdLineLoadingModule,
    AdDividerModule,
    AdButtonModule,
    AdMultipleDropdownModule,
    AdModalModule,
    AdCheckBoxModule,
    AdSkeletonModule,
    AdAlertModule,
    AdDialogModule,
    AdUploadModule,
    AdExpansionModule,
    AdDatePickerModule,
    CalendarModule,
    AdDateRangeModule,
    AdCommonModule,
    AdTooltipModule,
    AdUploadAreaModule,
    AdProgressModule,
    AdAutocompleteModule,
    AdSelectButtonModule,
    AdToggleButtonModule,
    ADateRangeSliderModule,
    EllipsisModule,
    UICarouselModule
  ],
  exports: [
    AdTabMenuModule,
    AdSelectModule,
    AdDropdownListModule,
    AdLinkMenuModule,
    AdLineLoadingModule,
    AdDividerModule,
    AdTextModule,
    AdButtonModule,
    AdMultipleDropdownModule,
    AdModalModule,
    AdCheckBoxModule,
    AdSkeletonModule,
    AdAlertModule,
    AdDialogModule,
    AdUploadModule,
    AdExpansionModule,
    AdDatePickerModule,
    AdDateRangeModule,
    AdCommonModule,
    AdTooltipModule,
    AdUploadAreaModule,
    AdProgressModule,
    AdAutocompleteModule,
    AdSelectButtonModule,
    AdToggleButtonModule,
    ADateRangeSliderModule,
    EllipsisModule,
    UICarouselModule
  ],
})
export class BasicComponentModule {
  static forChild(providers: Provider[]): ModuleWithProviders<BasicComponentModule> {
    return {
      ngModule: BasicComponentModule,
      providers,
    };
  }

  static forRoot(providers: Provider[] = []): ModuleWithProviders<BasicComponentModule> {
    return {
      ngModule: BasicComponentModule,
      providers: [
        ...CalendarModule.forRoot(
          {
            provide: DateAdapter,
            useFactory: adapterFactory,
          },
          {
            dateFormatter: {
              provide: CalendarDateFormatter,
              useClass: AdCalendarDateFormatter,
            },
          }
        ).providers,
        ...providers,
      ],
    };
  }
}
